<template>
  <div class="home">
    <NewItemsManager />
    <ReviewItemsManager />
    <MarkedItemsManager />
  </div>
</template>

<script>
import NewItemsManager from '@/components/NewItemsManager.vue'
import MarkedItemsManager from '@/components/MarkedItemsManager.vue'
import ReviewItemsManager from '@/components/ReviewItemsManager.vue'

export default {
  name: 'home',
  components: {
    NewItemsManager,
    MarkedItemsManager,
    ReviewItemsManager,
  }
}
</script>
